import React from 'react';
import moment from 'moment';

const ApiKeyList = ({ apiKeys, onRevoke, revoking }) => {
  const getStatusBadge = (apiKey) => {
    if (!apiKey.isActive) {
      return <span className="badge badge-danger">Ingetrokken</span>;
    }
    if (apiKey.expiresAt && moment(apiKey.expiresAt).isBefore(moment())) {
      return <span className="badge badge-warning">Verlopen</span>;
    }
    return <span className="badge badge-success">Actief</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return moment(dateStr).format('DD-MM-YYYY HH:mm');
  };

  if (apiKeys.length === 0) {
    return (
      <div className="text-muted text-center py-4">
        Geen API keys gevonden. Maak een nieuwe key aan om te beginnen.
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Naam</th>
            <th>Prefix</th>
            <th>Gebruiker</th>
            <th>Status</th>
            <th>Verloopt op</th>
            <th>Laatst gebruikt</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {apiKeys.map((apiKey) => (
            <tr key={apiKey.id} className={!apiKey.isActive ? 'text-muted' : ''}>
              <td>{apiKey.name}</td>
              <td>
                <code style={{ fontSize: '0.85em' }}>{apiKey.keyPrefix}...</code>
              </td>
              <td>{apiKey.createdBy || '-'}</td>
              <td>{getStatusBadge(apiKey)}</td>
              <td>{formatDate(apiKey.expiresAt)}</td>
              <td>{apiKey.lastUsedAt ? formatDate(apiKey.lastUsedAt) : 'Nooit'}</td>
              <td className="text-right">
                {apiKey.isActive && (
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={() => onRevoke(apiKey.id)}
                    disabled={revoking === apiKey.id}
                    title="API key intrekken"
                  >
                    {revoking === apiKey.id ? (
                      <i className="fa fa-spinner fa-spin" />
                    ) : (
                      <i className="fa fa-ban" />
                    )}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ApiKeyList;
